<template>
  <div class="min-h-screen bg-base-200 py-16 px-4 sm:px-6 lg:px-8">
    <div class="max-w-4xl mx-auto space-y-16 animate-fade-in-up">
      <!-- Hero -->
      <div class="text-center space-y-6">
        <h1 class="text-4xl md:text-5xl font-extrabold text-base-content tracking-tight">
          About <span class="text-primary">Aanza</span>
        </h1>
        <p class="text-xl text-base-content/80 max-w-2xl mx-auto">
          We are a Software as a Service (SaaS) company dedicated to revolutionizing how restaurants operate, helping owners manage their businesses easily and more efficiently.
        </p>
      </div>

      <!-- Features Grid -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div class="card bg-base-100 shadow-xl hover:-translate-y-1 transition-transform duration-300">
          <div class="card-body">
            <div class="text-primary mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm14 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z" /></svg>
            </div>
            <h3 class="card-title text-xl">QR Code Order Management</h3>
            <p class="text-base-content/70">Reduce staff dependency and let users place orders directly via their smartphones for a seamless, interactive experience.</p>
          </div>
        </div>

        <div class="card bg-base-100 shadow-xl hover:-translate-y-1 transition-transform duration-300">
          <div class="card-body">
            <div class="text-secondary mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" /></svg>
            </div>
            <h3 class="card-title text-xl">Stock & Employee Management</h3>
            <p class="text-base-content/70">Keep track of your inventory in real-time and manage your team efficiently all from one central dashboard.</p>
          </div>
        </div>
        
        <div class="card bg-base-100 shadow-xl md:col-span-2 hover:-translate-y-1 transition-transform duration-300">
          <div class="card-body text-center items-center">
            <div class="text-accent mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" /></svg>
            </div>
            <h3 class="card-title text-xl">Interactive Digital Menus</h3>
            <p class="text-base-content/70 max-w-lg">When scanning the QR code, users are presented with a beautiful, comprehensive digital menu complete with rich images and detailed food descriptions.</p>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<style scoped>
.animate-fade-in-up {
  animation: fadeInUp 0.6s ease-out;
}
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>
